import React, {Component} from 'react'
import ReactPlayer from 'react-player'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import ImageGallery from 'react-image-gallery'
import {Link} from 'react-router-dom'
import Pactilacel from "../Assets/Paclitaxel.jpg";
import Map from "../Assets/Map.jpg";
import {HashLink} from 'react-router-hash-link';

const linodeObjectUrl  = 'https://cdn.mannheim-urology.com/certificates'
const thumbnailsObjectUrl = `${linodeObjectUrl}/thumbnails`

const images = [
    {
        original: `${linodeObjectUrl}/Picture_1.JPG`,
        thumbnail: `${thumbnailsObjectUrl}/Picture_1.jpg`,
    },
    {
        original: `${linodeObjectUrl}/Picture_2.JPG`,
        thumbnail: `${thumbnailsObjectUrl}/Picture_2.jpg`,
    },
    {
        original: `${linodeObjectUrl}/Picture3.JPG`,
        thumbnail: `${thumbnailsObjectUrl}/Picture3.jpg`,
    }
]

const linodeObjectUrl2  = 'https://cdn.mannheim-urology.com/optilume/single_bulbar_strictures'
const linodeObjectUrl3  = 'https://cdn.mannheim-urology.com/optilume/bladder_neck_stricture'
const linodeObjectUrl4  = 'https://cdn.mannheim-urology.com/optilume/double_strictures'
const linodeObjectUrl5  = 'https://cdn.mannheim-urology.com/optilume/intraoperativ_endoscopic'

const images_linodeObjectUrl2 = [
    {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0001.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0001.jpg`,
    },
    {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0002.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0002.jpg`,
    },
     {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0003.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0003.jpg`,
    },
     {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0004.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0004.jpg`,
    },
       {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0005.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0005.jpg`,
    },
       {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0006.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0006.jpg`,
    },
       {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0007.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0007.jpg`,
    },
       {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0008.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0008.jpg`,
    },
       {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0009.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0009.jpg`,
    },
       {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0010.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0010.jpg`,
    },
       {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0011.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0011.jpg`,
    },
       {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0012.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0012.jpg`,
    },
       {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0013.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0013.jpg`,
    },
       {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0014.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0014.jpg`,
    },
       {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0015.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0015.jpg`,
    },
       {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0016.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0016.jpg`,
    },
    
       {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0017.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0017.jpg`,
    },
    
]


const images_linodeObjectUrl3 = [
    {
        original: `${linodeObjectUrl3}/bladder_neck_stricture_1.jpg`,
        thumbnail: `${linodeObjectUrl3}/thumb-bladder_neck_stricture_1.jpg`,
    },
    {
        original: `${linodeObjectUrl3}/bladder_neck_stricture_2.jpg`,
        thumbnail: `${linodeObjectUrl3}/thumb-bladder_neck_stricture_2.jpg`,
    },
     {
        original: `${linodeObjectUrl3}/bladder_neck_stricture_3.jpg`,
        thumbnail: `${linodeObjectUrl3}/thumb-bladder_neck_stricture_3.jpg`,
    },
     {
        original: `${linodeObjectUrl3}/bladder_neck_stricture_4.jpg`,
        thumbnail: `${linodeObjectUrl3}/thumb-bladder_neck_stricture_4.jpg`,
    },
       {
        original: `${linodeObjectUrl3}/bladder_neck_stricture_5.jpg`,
        thumbnail: `${linodeObjectUrl3}/thumb-bladder_neck_stricture_5.jpg`,
    },
       {
        original: `${linodeObjectUrl3}/bladder_neck_stricture_6.jpg`,
        thumbnail: `${linodeObjectUrl3}/thumb-bladder_neck_stricture_6.jpg`,
    },
       {
        original: `${linodeObjectUrl3}/bladder_neck_stricture_7.jpg`,
        thumbnail: `${linodeObjectUrl3}/thumb-bladder_neck_stricture_7.jpg`,
    },
       {
        original: `${linodeObjectUrl3}/bladder_neck_stricture_8.jpg`,
        thumbnail: `${linodeObjectUrl3}/thumb-bladder_neck_stricture_8.jpg`,
    },
       {
        original: `${linodeObjectUrl3}/bladder_neck_stricture_9.jpg`,
        thumbnail: `${linodeObjectUrl3}/thumb-bladder_neck_stricture_9.jpg`,
    },
       {
        original: `${linodeObjectUrl3}/bladder_neck_stricture_10.jpg`,
        thumbnail: `${linodeObjectUrl3}/thumb-bladder_neck_stricture_10.jpg`,
    },
       {
        original: `${linodeObjectUrl3}/bladder_neck_stricture_11.jpg`,
        thumbnail: `${linodeObjectUrl3}/thumb-bladder_neck_stricture_11.jpg`,
    },
       {
        original: `${linodeObjectUrl3}/bladder_neck_stricture_12.jpg`,
        thumbnail: `${linodeObjectUrl3}/thumb-bladder_neck_stricture_12.jpg`,
    },
       {
        original: `${linodeObjectUrl3}/bladder_neck_stricture_13.jpg`,
        thumbnail: `${linodeObjectUrl3}/thumb-bladder_neck_stricture_13.jpg`,
    },
       {
        original: `${linodeObjectUrl3}/bladder_neck_stricture_14.jpg`,
        thumbnail: `${linodeObjectUrl3}/thumb-bladder_neck_stricture_14.jpg`,
    },
       {
        original: `${linodeObjectUrl3}/bladder_neck_stricture_15.jpg`,
        thumbnail: `${linodeObjectUrl3}/thumb-bladder_neck_stricture_15.jpg`,
    },
 
    
]



const images_linodeObjectUrl4 = [
    {
        original: `${linodeObjectUrl4}/double_strictures_1.jpg`,
        thumbnail: `${linodeObjectUrl4}/thumb-double_strictures_1.jpg`,
    },
    {
        original: `${linodeObjectUrl4}/double_strictures_2.jpg`,
        thumbnail: `${linodeObjectUrl4}/thumb-double_strictures_2.jpg`,
    }, 
    {
        original: `${linodeObjectUrl4}/double_strictures_3.jpg`,
        thumbnail: `${linodeObjectUrl4}/thumb-double_strictures_3.jpg`,
    },
    {
        original: `${linodeObjectUrl4}/double_strictures_4.jpg`,
        thumbnail: `${linodeObjectUrl4}/thumb-double_strictures_4.jpg`,
    },
    {
        original: `${linodeObjectUrl4}/double_strictures_5.jpg`,
        thumbnail: `${linodeObjectUrl4}/thumb-double_strictures_5.jpg`,
    },
    {
        original: `${linodeObjectUrl4}/double_strictures_6.jpg`,
        thumbnail: `${linodeObjectUrl4}/thumb-double_strictures_6.jpg`,
    },
    {
        original: `${linodeObjectUrl4}/double_strictures_7.jpg`,
        thumbnail: `${linodeObjectUrl4}/thumb-double_strictures_7.jpg`,
    },
    {
        original: `${linodeObjectUrl4}/double_strictures_8.jpg`,
        thumbnail: `${linodeObjectUrl4}/thumb-double_strictures_8.jpg`,
    },
    {
        original: `${linodeObjectUrl4}/double_strictures_9.jpg`,
        thumbnail: `${linodeObjectUrl4}/thumb-double_strictures_9.jpg`,
    },
    {
        original: `${linodeObjectUrl4}/double_strictures_10.jpg`,
        thumbnail: `${linodeObjectUrl4}/thumb-double_strictures_10.jpg`,
    },
    {
        original: `${linodeObjectUrl4}/double_strictures_11.jpg`,
        thumbnail: `${linodeObjectUrl4}/thumb-double_strictures_11.jpg`,
    },
    {
        original: `${linodeObjectUrl4}/double_strictures_12.jpg`,
        thumbnail: `${linodeObjectUrl4}/thumb-double_strictures_12.jpg`,
    },
    {
        original: `${linodeObjectUrl4}/double_strictures_13.jpg`,
        thumbnail: `${linodeObjectUrl4}/thumb-double_strictures_13.jpg`,
    },
            
]



colorLinks("#11ABB0");

function colorLinks(hex)
{
    var links = document.getElementsByTagName("a");
    for(var i=0;i<links.length;i++)
    {
        if(links[i].href)
        {
            links[i].style.color = hex;  
        }
    }  
}



const MyReactPlayer = () => {
  return (
    <div style={{ position: 'relative', width: '75%', height: '500px' }}>
      <ReactPlayer
        url="https://cdn.mannheim-urology.com/videos/Optilume_video2.mp4"
        width="100%"
        height="100%"
        controls={true} startTime={7.0} playing={false}
        style={{ position: 'absolute', top: 0, left: 100 }} 
      />
    </div>
  );
};

const MyReactPlayer2 = () => {
  return (
    <div style={{ position: 'relative', width: '75%', height: '500px' }}>
      <ReactPlayer
        url="https://cdn.mannheim-urology.com/videos/Optilume_video_Tosev.mp4"
        width="100%"
        height="100%"
        light='https://cdn.mannheim-urology.com/videos/Optilume_video_Tosev.png'
        controls={true} startTime={7.0} playing={true}
        style={{ position: 'absolute', top: 0, left: 100 }} 
      />
    </div>
  );
};


const Optilume = () => {
    const {t} = useTranslation()
    const language = useSelector(state => state.language)

    switch (language) {
        case 'BG':
            return (
                <section id="about1">
                    <div className="row">
                        <h2>Обещаваща нова технология дава надежда на милиони мъже в цяла Европа, страдащи от стриктурa
                            на уретрата (стесняванe на пикочния канал)</h2>
                        <p className="white">
                            <strong>Д-р Георги Тосев е първият в Европа, провел минимално инвазивна терапия на
                                уретралната стриктура по метода Optilume. Процедурата се извършва амбулаторно,
                                изключително щадяща за пациента и с висока успеваемост. </strong><br/>
                            Нов минимално инвазивен метод за лечение на уретрални стриктури (стеснения на пикочния
                            канал) с балонен катетър с лекарствено покритие (Paclitaxel) Optilume започва да се прилага
                            в Европа. Методът Optilume е резултат на стратегическата кооперация между водещата компания
                            за диагностични и терапевтични медицински технологии Laborie Medical Technologies и
                            американската фирма Urotronic. Новата техника е регистрирана и одобрена за употреба в ЕС от
                            септември 2020 г., а първата минимално инвазивна операция е проведена от д-р Георги Тосев в
                            Манхайм, Германия в партньорския Ambassador Center през януари 2021 г. и показва
                            впечатляващи клинични резултати.<br/>
                            <h2>Какво представлява новият метод Optilume</h2>
                            При тази иновативна минимално инвазивна процедура балонен катетър с лекарствено покритие
                            (Paclitaxel) (вж. фиг. 1) се вкарва в уретрата и се поставя в областта на стеснението. <br/>
                            <img src={Pactilacel}/> <br/>
                            <hr/>
                            След това стеснението на пикочния канал се разширява чрез разгъване на балона.
                            Химиотерапевтичната субстанция (Paclitaxel) се резорбира в съединителната тъкан на
                            стриктурата, заобикаляща балона. След това освободеното вещество остава около един месец и
                            спира растежа на тъкан в стеснената област. По този начин се противодейства на развитието и
                            образуването на нова съединителна тъкан. Операцията продължава само 30 минути, като
                            пациентът е под лека обща упойка. Самата манипулация е бърза и дава възможност за
                            възстановяване в рамките на деня. Лечението с Optilume не налага болничен прием, след
                            операцията се поставя уретрален катетър за 2 дни.<br/>
                            С този метод могат да се лекуват стриктури с дължина до 3 см в предната част ( булбарен и
                            пенилен дял) на уретрата (вж. фиг. 2). Актуалните изследвания с проследяващ период до три
                            години показват успеваемост над 75% на оперативното лечение, а рецидивът е сведен до около
                            25%. Качеството на живот, уринният лъч и остатъчният обем на урината се подобряват
                            значително спрямо изходното ниво. Силата на уринния лъч след 36 месеца е средно над 240%
                            по-висока от тази преди лечението (източник ROBUST 1 Study, Urotronic Inc.). <br/>
                            Единствените минимални странични ефекти, които се наблюдават, са временно парене при
                            уриниране и инфекция на пикочните пътища, която се третира с антибиотици. Няма съобщения за
                            сериозни нежелани дългосрочни последици, причинени от процедурата.<br/>
                            <h2>Признаци за стеснение на пикочния канал:</h2>
                            Стриктурата на уретрата е стесняванe на пикочния канал, причинено от нараняване, възпаление
                            или инфекция, което възниква в резултат на прекомерно развитие на съединителна тъкан. Това е
                            причина за затруднения в уринирането като слаба струя, повишена остатъчна урина, често
                            уриниране, болка при уриниране или еякулация, както и кръв в урината или спермата. Уретрата
                            е едновременно част от отделителната и от репродуктивната система и нарушенията в нейната
                            форма и функция са важен медицински и социален проблем. Тя значително намалява качеството на
                            живот и може да доведе до усложнения като инфекции на пикочните пътища, възпаление на
                            простатата, задържане на урина или увреждане на бъбреците. Лечението има за основна цел
                            пациентът да уринира със задоволителна струя и да контролира процеса на уриниране.<br/>


                        <ImageGallery items={images}/>
                        <MyReactPlayer/><br/>
                        <MyReactPlayer2/><br/>

                    <p>Вижте снимки от някои от нашите документирани <a href='#link_to_picsBG' style={{ color: '#11ABB0' }} >случаи:</a>
                       </p>
                            <h2>Настоящи други възможности за лечение:</h2>
                            Обикновената дилатация (разширяване без прилагане на химиотерапевтично вещество) и
                            вътрешната уретротомия (ендоскопско проведен срез на пикочния канал) се предлагат като
                            минимално инвазивни процедури. И при двата метода е възможен рецидив в поне 50 до 60% от
                            случаите. Те намират приложение най-вече при стесняване на уретрата близо до външния
                            уретрален сфинктер, който разделя уретрата на преден и заден дял (вж. фиг. 2), тъй като
                            всяка друга форма на терапия (напр. долупосочената отворена операция с уретрална пластика)
                            би била значително по-инвазивна и крие сериозни следоперативни рискове.<br/>
                            При т. нар. отворен метод пикочният канал се разрязва над стеснението и се пришива с парче
                            лигавица (graft) със съответния размер и дължина, взето най-често от устната кухина. След
                            операцията се поставя катетър, който да поддържа уретрата отворена за около седмица, и втори
                            катетър през коремната стена, който помага за изпразване на пикочния мехур. В зависимост от
                            последващото възстановяване коремният катетър се премахва след около три до четири седмици.
                            Според локализацията на стеснението операцията може да доведе до повишен риск от
                            инконтиненция (спонтанно изпускане на урина), еякулаторна и еректилна дисфункция, уретрална
                            фистула, нараняване на нервите или пещеристите тела на пениса, болки в устата и прочие.<br/>
                            Степента на успех при операция с отворен разрез е значително по-висока отколкото при
                            досегашните минимално инвазивни процедури (дилатация или вътрешна уретротомия), но е
                            стресираща за пациента и поставя високи изисквания към опита на лекуващия хирург. Освен
                            това, пациентът е подложен на многочасова операция и подлежи на поне 20-30-дневно
                            следоперативно наблюдение. <br/>
                            <img src={Map} alt="Пикочни пътища"/>
                            <hr/>
                            <h2>Заключение</h2>
                            Optilume е метод с потенциал да промени представите за успешно лечение при стеснение на
                            пикочния канал. Той комбинира предимствата на минимално инвазивната хирургия с дългогодишно
                            разработвани потентни субстанции. Терапията показва забележителни следоперативни резултати
                            по сведения от редица научни проучвания (Robust Study I). Едно от най-големите предимства на
                            лечението е възможността за амбулаторно, безстресово, провеждане и възстановяване в рамките
                            на часове. Очаква се методът да доведе до значително намаляване на разходите по лечение на
                            заболяването поради сигурното прилагане и високата дългосрочна успеваемост.<br/>
                        </p>

                    </div>
                    <div className="row" id="link_to_picsBG">
                    <h2>Single Bulbar Strictures</h2>
                                            <ImageGallery items={images_linodeObjectUrl2} style={{ width: '80%'}}/>
                    <h2>Bladder Neck Stricture</h2>
                                            <ImageGallery items={images_linodeObjectUrl3} style={{ width: '80%'}}/>
                    <h2>Double Strictures</h2>
                                            <ImageGallery items={images_linodeObjectUrl4} style={{ width: '80%'}}/>
                    </div>
                </section>
            )
        default:
            return (
                <section id="about1">
                    <div className="row">
                    <h3>Optilume Treatment for Urethral Strictures</h3>
                    <p>Dr. Georgi Tosev, a leading urologist in Europe, successfully performed the first Optilume treatment on an outpatient basis. Optilume is a drug-coated balloon (DCB) technology for use in urethral strictures and benign prostatic hyperplasia (BPH) that was recently granted CE Mark approval in Europe. 

                    <p>Dr. Tosev is a leading urologist in Europe, having performed over 150 successful Optilume procedures. This accounts for more than 30% of all Optilume Operations performed in Europe. The procedure has also been used off-label to treat patients with recurrent bladder neck stricture, meatal stenosis, and even complicated double stenosis. To ensure our patients receive the best possible care, we use an innovative App for digital uroflowmetry that allows us to detect possible recurrence of the stricture at an early stage.</p>

                    <p>Laborie Medical Technologies Inc. (LABORIE) announced the first Optilume procedures were performed in Mannheim, Germany on January 22, 2021. LABORIE and Urotronic Inc. (Urotronic) entered into a strategic partnership in October 2020 to support regulatory approval of Optilume in the United States. Urotronic, a Minnesota-based medical device company, is currently conducting clinical trials in the United States for the technology.</p>
                        <ImageGallery items={images}/>
                        <MyReactPlayer/>
                        <MyReactPlayer2/><br/>

                    <p>Urethral strictures can be caused by infections, trauma, and other medical procedures that injure the lining of the urethra. Over a million men throughout Europe suffer from the condition, which can block the pathway for urine to exit the body from the bladder and result in a painful, frustrating slowing of the urinary system. Optilume is a promising treatment option that offers better success rates than conventional balloon dilatation and is less invasive than urethroplasty.</p>
                    <p>According to Dr. Tosev, "Patients have frequent relapses after direct visualization internal urethrotomy. Many of them fear a more invasive therapy in the sense of an open urethroplasty. The balloon seems to be a good compromise."</p>
                    <p>Dr. Tosev summarized, "I think that Optilume will become a game changer in the treatment of the urethral strictures."</p>
                    <p>See more in: <a href='https://www.urologytimes.com/view/first-european-patient-treated-for-urethral-strictures-with-novel-drug-coated-balloon-catheter'
                            target='_blank' style={{ color: '#11ABB0' }}
                        >https://www.urologytimes.com</a>
                          </p>

                    <p>Check some images of our documented <a href='#link_to_pics' style={{ color: '#11ABB0' }} >cases:</a>
                          </p>

                          </p>


                        <hr/>
                        <h2>{t('optilume.block_1')}</h2>
                        <hr/>
                        <p className="white">
                            <h2>{t('optilume.block_2')}</h2><br/>
                            {t('optilume.block_3')}
                        </p>
                        <h2>{t('optilume.block_4')}</h2>
                        <p> 
The most common symptoms of urethral stricture are related to difficulty with urination. These may include:</p>
 
                        <ol>
                            <li>{t('optilume.list_1.1')}</li>
                            <li>{t('optilume.list_1.2')}</li>
                            <li>{t('optilume.list_1.3')}</li>
                            <li>{t('optilume.list_1.4')}</li>
                            <li>{t('optilume.list_1.5')}</li>
                            <li>{t('optilume.list_1.6')}</li>
                            <li>{t('optilume.list_1.7')}</li>
                            <li>{t('optilume.list_1.8')}</li>
                            <li>{t('optilume.list_1.9')}</li>
                            <li>{t('optilume.list_1.10')}</li>
                            <li>{t('optilume.list_1.11')}</li>
                        </ol>
                        <hr/>
    
                    <h2>What are the causes of urethral stricture:</h2>

                        <p> 
Urethral stricture is caused by a narrowing or obstruction of the urethra, the tube that carries urine out of the body. The most common causes of urethral stricture include:</p>


                        <ol>
                            <li>Trauma: Injury to the urethra, such as from a pelvic fracture or catheterization, can cause scar tissue to form and narrow the urethra.</li>
                            <li>Infection: Certain sexually transmitted infections, such as gonorrhea or chlamydia, can cause inflammation and scarring of the urethra.</li>
                            <li>Medical procedures: Certain medical procedures, such as prostate surgery or radiation therapy for prostate cancer, can cause damage to the urethra and lead to stricture formation.</li>
                            <li>Idiopathic: In some cases, the cause of urethral stricture is unknown, which is referred to as idiopathic urethral stricture.</li>
                            <li>Congenital: Rarely, urethral strictures can be present from birth due to abnormal development of the urethra.</li>
                            <li>Other less common causes of urethral stricture include certain medications, inflammation or autoimmune conditions, and previous urethral surgeries.</li>
                            <li>Identifying the underlying cause of urethral stricture is important for guiding treatment and preventing recurrence.</li>
 
                        </ol>
                        <hr/>
 

                    <h2>{t('optilume.block_4b')}</h2>
                         {t('optilume.block_4c')} 
                        <hr/>



    
                    <h2>The diagnosis of urethral stricture:</h2>

                        <p> 
The diagnosis of urethral stricture typically involves a combination of medical history, physical examination, and diagnostic tests.

During a medical history, the doctor may ask about symptoms such as difficulty urinating, urinary frequency, and pain or discomfort during urination. They may also ask about past medical history, including any surgeries or medical procedures involving the urinary tract.

A physical examination may involve the doctor palpating the lower abdomen and examining the genital area for any signs of swelling, redness, or discharge. They may also perform a digital rectal exam to check for any abnormalities in the prostate gland or surrounding tissues.

Diagnostic tests that may be used to confirm the diagnosis of urethral stricture include:</p>


                        <ol>
                            <li>Urine tests: A urine sample may be collected and examined for signs of infection or blood.</li>
                            <li>Imaging tests: Imaging tests such as an ultrasound or a retrograde urethrogram (an X-ray of the urethra) may be used to visualize the urethra and identify any narrowing or obstruction.</li>
                            <li>Uroflowmetry: This is a test that measures the speed and volume of urine flow to determine the severity of the obstruction.</li>
                            <li>Cystoscopy: A small camera is inserted into the urethra to visualize the area and determine the location and severity of the stricture.</li>
                        </ol>
                        <p> 
Once the diagnosis of urethral stricture is confirmed, the underlying cause may be investigated through additional tests, and a treatment plan can be developed. Early diagnosis and treatment are important in preventing complications and improving outcomes.</p>
                        <hr/>



                    <h2>What are the current standard treatments of urethral stricture?</h2>

The treatment of urethral stricture typically involves a combination of medical therapies, minimally invasive procedures, and surgical interventions. The choice of treatment depends on the location and severity of the stricture, as well as the individual patient's overall health and preferences. Some common standard therapies for the treatment of urethral stricture include:

                        <ol>
                            <li>Urethral dilation: This is a minimally invasive procedure where a specialized instrument is inserted into the urethra to stretch the narrowed area. This may be done with a series of gradually larger instruments to gradually widen the urethra.</li>
                            <li>Urethrotomy: This is a minimally invasive procedure where a small incision is made in the urethra to widen the area of narrowing.</li>
                            <li>Urethroplasty: This is a surgical procedure where the narrowed portion of the urethra is removed, and the remaining ends are reconnected. This may involve the use of tissue grafts or other reconstructive techniques.</li>
                            <li>Placement of a urethral stent: This is a minimally invasive procedure where a small tube is inserted into the urethra to keep it open. This may be used as a temporary measure or as a palliative treatment for those who are not candidates for more invasive procedures.</li>
                        </ol>

                        <hr/>
    
                    <h2>What are the disadvantages of the current endoscopic treatment options?</h2>

The choice of treatment depends on various factors, including the location and severity of the stricture, the patient's overall health, and preferences. It is important to consult with us to determine the best course of treatment for an individual patient.
While endoscopic treatment options for urethral stricture have been effective for many patients, there are several disadvantages to these treatments that should be considered:


                        <ol>
                            <li>High recurrence rates: Endoscopic procedures such as urethral dilation or urethrotomy have a high rate of recurrence, with up to 50% of patients requiring repeat procedures within a year.</li>
                            <li>Risk of complications: Endoscopic procedures carry a risk of complications such as bleeding, infection, or perforation of the urethra. These complications can be serious and may require further medical intervention.</li>
                            <li>Limited effectiveness for complex strictures: Endoscopic procedures are typically less effective for complex strictures that involve longer segments of the urethra or areas of severe scarring. These may require more invasive surgical procedures for successful treatment.</li>
                            <li>Need for repeated procedures: Endoscopic procedures may require repeated treatments over time, which can be inconvenient and uncomfortable for patients.</li>
                            <li>Cost: Endoscopic procedures can be expensive, especially if multiple treatments are required. This can be a barrier to accessing treatment for some patients.</li>
                        </ol>

    

 


                        <hr/>
    
                        <h2>{t('optilume.block_6')}</h2>

                        {t('optilume.block_7')}
                        <br/>
                        {t('optilume.block_8')}
                        <br/>
                        {t('optilume.block_9')}
                        <hr/>
                        <h2>{t('optilume.block_10')}</h2>
                        <br/>
                        {t('optilume.block_11')}
                        <br/>
                        {t('optilume.block_12')}
                        <br/>
<br/>
                        <h2> {t('optilume.block_13')}</h2>
                        <ol>
                            <li>{t('optilume.list_2.1')}</li>
                            <li>{t('optilume.list_2.2')}</li>
                            <li>{t('optilume.list_2.3')}</li>
                            <li>{t('optilume.list_2.4')}</li>
                            <li>{t('optilume.list_2.5')}</li>
                        </ol>
                        <hr/>
                        <h2>{t('optilume.block_14')}</h2>
                        <br/>
                        {t('optilume.block_15')}
                        <ol>
                            <li>{t('optilume.list_3.1')}</li>
                            <li>{t('optilume.list_3.2')}</li>
                            <li>{t('optilume.list_3.3')}</li>
                            <li>{t('optilume.list_3.4')}</li>
                        </ol>
                        <br/>
                         <hr/>

                        <h2>What do I do after the Optilume procedure?</h2>

After the Optilume procedure, you will need to arrange for an adult to pick you up as you will not be able to drive or perform any hazardous activities for 24 hours if you have analgosedation. It's important to avoid any sexual activity, including masturbation, for at least 14 days after the procedure, and for an additional 2 weeks using a condom. If you experience any unusual symptoms or complications, such as bleeding, increased pain, or fever, please contact us immediately.
                         <hr/>
                        <br/>
                    </div>
                    <div className="row" id="link_to_pics">
                    <h2>Single Bulbar Strictures</h2>
                                            <ImageGallery items={images_linodeObjectUrl2} style={{ width: '80%'}}/>
                    <h2>Bladder Neck Stricture</h2>
                                            <ImageGallery items={images_linodeObjectUrl3} style={{ width: '80%'}}/>
                    <h2>Double Strictures</h2>
                                            <ImageGallery items={images_linodeObjectUrl4} style={{ width: '80%'}}/>
                    </div>
                </section>



            )
    }
}

export default Optilume



// WEBPACK FOOTER //
// ./src/Components/Optilume.js